import { ArrowLeftIcon, PlusIcon } from "@vetty/icons";
import { Button, Tabs, TabsItem } from "@/components";
import {
  MODEL_DETAIL_VERSION_FILTER_ITEMS,
  type ModelDetailVersionsFilter,
} from "../../_constants/model-detail-toolbar.const";
import styles from "./ModelDetailToolbar.module.scss";

type ModelDetailToolbarProps = {
  filter: ModelDetailVersionsFilter;
  onFilterChange: (value: ModelDetailVersionsFilter) => void;
  onAddVersionClick: () => void;
};

export const ModelDetailToolbar = ({
  filter,
  onFilterChange,
  onAddVersionClick,
}: ModelDetailToolbarProps) => {
  return (
    <div className={styles["comp"]}>
      <div className={styles["comp__leading"]}>
        <Button
          href="/models"
          size="medium"
          variant="secondary"
          startContent={
            <ArrowLeftIcon style={{ width: 20, height: 20 }} aria-hidden />
          }
        >
          Back to library
        </Button>
        <Tabs
          value={filter}
          onChange={(value) =>
            onFilterChange(value as ModelDetailVersionsFilter)
          }
          variant="secondary"
          size="medium"
        >
          {MODEL_DETAIL_VERSION_FILTER_ITEMS.map((item) => (
            <TabsItem key={item.value} value={item.value}>
              {item.label}
            </TabsItem>
          ))}
        </Tabs>
      </div>

      <div className={styles["comp__actions"]}>
        <Button
          size="medium"
          variant="primary"
          startContent={<PlusIcon style={{ width: 20, height: 20 }} />}
          onClick={onAddVersionClick}
        >
          Add new version
        </Button>
      </div>
    </div>
  );
};
